(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-dfg-home]').forEach(home => {
      if (home.dataset.dfgInitialized) return;
      home.dataset.dfgInitialized = 'true';
      const image = home.querySelector('[data-dfg-scene-image]');
      const caption = home.querySelector('[data-dfg-scene-caption]');
      home.querySelectorAll('[data-dfg-scene]').forEach(button => {
        button.addEventListener('click', () => {
          if (!image || !button.dataset.dfgSrc) return;
          if (button.dataset.dfgSizes) image.sizes = button.dataset.dfgSizes;
          else image.removeAttribute('sizes');
          if (button.dataset.dfgSrcset) image.srcset = button.dataset.dfgSrcset;
          else image.removeAttribute('srcset');
          image.src = button.dataset.dfgSrc;
          image.alt = button.dataset.dfgAlt || '';
          if (caption) caption.textContent = button.dataset.dfgCaption || '';
          home.querySelectorAll('[data-dfg-scene]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        });
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
